<template>
  <div>
    <v-overlay :value="isLoadingSpinner" :opacity="`0.5`" zIndex="99999"
      ><v-progress-circular
        indeterminate
        size="70"
        width="7"
        color="primary"
      ></v-progress-circular
    ></v-overlay>
    <v-card elevation="2" outlined shaped tile>
      <v-card-title>{{ $t("navbar.user_admin") }}</v-card-title>
      <v-snackbar v-model="snackbar" :color="snackbar_class" elevation="24">
        {{ text_snackbar }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>

      <v-dialog
        v-if="selected"
        persistent
        scrollable
        v-model="showEdit"
        max-width="600px"
      >
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="selected.username"
                      v-bind:label="$t('salesforce.UserName')"
                      required
                      :rules="usernameRules"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="selected.name"
                      v-bind:label="$t('salesforce.name')"
                      required
                      :rules="requiredRules"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="selected.surname"
                      v-bind:label="$t('salesforce.SurName')"
                      required
                      :rules="requiredRules"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="selected.residence"
                      v-bind:label="$t('salesforce.ResidenceCity')"
                      required
                      :rules="requiredRules"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-autocomplete
                      v-model="selected.provincia"
                      label="Provincia"
                      :items="provinceItems"
                      filled
                      required
                      :rules="requiredRules"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="selected.email"
                      v-bind:label="$t('salesforce.email')"
                      required
                      :rules="selected.status === 'inactive' ? [] : emailRules"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="selected.phone"
                      v-bind:label="$t('salesforce.phone')"
                      required
                      :rules="lengthRules"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="selected.phone_company"
                      v-bind:label="$t('salesforce.phone_company')"
                      required
                      :rules="lengthRules"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="selected.dni"
                      v-bind:label="$t('salesforce.dni')"
                      required
                      :rules="[...requiredRules, ...lengthRules]"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-autocomplete
                      v-model="selected.brands"
                      v-bind:label="$t('project')"
                      v-bind:placeholder="$t('start_typing_to_search')"
                      item-text="name"
                      item-value="id"
                      :search-input.sync="search_projects"
                      :loading="isProjectsSearching"
                      :items="filtered_projects"
                      hide-no-data
                      filled
                      multiple
                      clearable
                      @change="onBrandOrRoleChange"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="selected.discount_km"
                      v-bind:label="$t('discount_km')"
                      :type="'number'"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-autocomplete
                      v-model="selected.role"
                      v-bind:label="$t('salesforce.user_type')"
                      :items="user_type"
                      filled
                      required
                      :rules="requiredRules"
                      @change="onBrandOrRoleChange"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-autocomplete
                      v-model="selected.department"
                      :label="$t('salesforce.department')"
                      :items="departments"
                      filled
                      clearable
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row v-if="selected.role === 'brand'">
                  <v-col cols="12" sm="6" md="6" lg="6">
                    <v-autocomplete
                      v-model="selected.brandSurveys"
                      label="Encuestas"
                      v-bind:placeholder="$t('start_typing_to_search')"
                      item-text="name"
                      item-value="id"
                      :search-input.sync="search_surveys"
                      :loading="isSearching['surveys']"
                      :items="filtered_surveys"
                      hide-no-data
                      filled
                      multiple
                      clearable
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="6" lg="6"
                    ><v-autocomplete
                      v-model="selected.anadimos_exports"
                      :label="`Añadimos Exports`"
                      :items="['SI', 'NO']"
                      filled
                      required
                      :rules="requiredRules"
                    ></v-autocomplete
                  ></v-col>
                </v-row>
                <v-row v-if="selected.role === 'brand'">
                  <v-col cols="12" sm="12" md="12">
                    <v-autocomplete
                      ref="brandReportsField"
                      v-model="selected.brandReports"
                      label="Reportes"
                      v-bind:placeholder="$t('start_typing_to_search')"
                      item-text="name"
                      item-value="id"
                      :search-input.sync="search_reports"
                      :loading="isSearching['reports']"
                      :items="filtered_reports"
                      hide-no-data
                      filled
                      multiple
                      clearable
                      
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row v-if="selected.role === 'brand'">
                  <v-col cols="12" sm="12" md="6"
                    ><v-autocomplete
                      v-model="selected.isEdit"
                      :label="`es editar`"
                      :items="['Editar', 'No editar']"
                      filled
                      required
                      :rules="requiredRules"
                    ></v-autocomplete
                  ></v-col>
                  <v-col cols="12" sm="12" md="6"
                    ><v-autocomplete
                      v-model="selected.landingPage"
                      :label="`Página de destino`"
                      :items="landingPages"
                      filled
                      required
                      :rules="requiredRules"
                    ></v-autocomplete
                  ></v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-autocomplete
                      v-model="selected.parent_id"
                      v-bind:label="$t('salesforce.Parent')"
                      :items="user_list"
                      item-text="username"
                      item-value="id"
                      filled
                      clearable
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-autocomplete
                      v-model="selected.routes"
                      :label="$t('route')"
                      :items="routes"
                      item-text="name"
                      item-value="id"
                      filled
                      clearable
                      :required="isRequiredRoute"
                      :rules="isRequiredRoute ? requiredRules : []"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-autocomplete
                      v-model="selected.companyCode"
                      :label="$t('Company')"
                      :items="companies"
                      item-text="name"
                      item-value="id"
                      filled
                      required
                      :rules="requiredRules"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="selected.dateEndOfVacation"
                      v-bind:label="`Fecha Fin Vacaciones`"
                      clearable
                      required
                      :rules="requiredRules"
                      @change="onChangeDateEndOfVacation"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <h6 class="my-2">Introduce la nueva dirección:</h6>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="selected.address"
                      v-bind:label="$t('address')"
                      v-if="this.isManualAddress"
                      outlined
                      class="editpos_input"
                      :readonly="this.isManualAddress"
                    ></v-text-field>
                    <input
                      v-model="selected.address"
                      type="text"
                      :placeholder="$t('address')"
                      ref="googleaddressbar"
                      class="googleAddressFinder pac-target-input"
                      autocomplete="off"
                      v-show="!this.isManualAddress"
                      :readonly="this.isManualAddress"
                    />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="selected.town"
                      v-bind:label="$t('town')"
                      required
                      :rules="!this.isManualAddress ? requiredRules : []"
                      hide-details="auto"
                      outlined
                      class="editpos_input"
                      :readonly="this.isManualAddress"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-text-field
                      v-model="selected.postalCode"
                      label="CP"
                      required
                      :rules="!this.isManualAddress ? requiredRules : []"
                      hide-details="auto"
                      outlined
                      class="editpos_input"
                      :readonly="this.isManualAddress"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="selected.addressObservation"
                      v-bind:label="$t('address observation')"
                      hide-details="auto"
                      outlined
                      class="editpos_input"
                      :readonly="this.isManualAddress"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row class="mb-1" v-if="manualData" v-show="isManualAddress">
                  <v-col cols="12" sm="12" md="12">
                    <h6 class="my-2">
                      Introduce manualmente la nueva dirección:
                    </h6>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="manualData.address"
                          v-bind:label="$t('address')"
                          required
                          :rules="this.isManualAddress ? requiredRules : []"
                        ></v-text-field
                      ></v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field
                          v-model="manualData.town"
                          v-bind:label="$t('town')"
                          required
                          :rules="this.isManualAddress ? requiredRules : []"
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="6">
                        <v-text-field
                          v-model="manualData.postalCode"
                          label="CP"
                          required
                          :rules="this.isManualAddress ? requiredRules : []"
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="manualData.addressObservation"
                          v-bind:label="$t('address observation')"
                          hide-details="auto"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="12" offset-sm="0" md="12">
                    <div class="text-right">
                      <a style="color: #1976d2;" @click="toggleCantfindAddress">
                        La dirección no sale
                      </a>
                    </div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-btn
                          color="primary"
                          class="ml-2 white--text"
                          @click="addNewDateEntry"
                        >
                          <v-icon dark>mdi-plus</v-icon> añadir
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <table
                          class="table b-table table-striped table-bordered table-sm b-table-stacked-sm routepage_ps_table mb-0"
                        >
                          <colgroup>
                            <col width="40%" />
                            <col width="40%" />
                            <col width="20%" />
                          </colgroup>
                          <tr>
                            <th class="text-center">
                              {{ $t("brands.start_date") }}
                            </th>
                            <th class="text-center">
                              {{ $t("brands.end_date") }}
                            </th>
                            <th class="text-center"></th>
                          </tr>
                          <template
                            v-if="selected.user_date_entries.length > 0"
                          >
                            <tr
                              v-for="(date_item,
                              date_item_key) in selected.user_date_entries"
                              :key="`date_table_row_${date_item_key}`"
                            >
                              <td class="text-center">
                                <v-menu
                                  ref="start_date_menu"
                                  v-model="select_start_date_menu"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="auto"
                                  v-if="
                                    isLastUserDateEntry(
                                      selected.user_date_entries,
                                      date_item_key
                                    )
                                  "
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="
                                        selected.user_date_entries[
                                          date_item_key
                                        ].userStartDate
                                      "
                                      v-bind:label="$t('brands.start_date')"
                                      prepend-icon="mdi-calendar"
                                      v-bind="attrs"
                                      v-on="on"
                                      readonly
                                      required
                                      :rules="
                                        selected.isSelectableDates
                                          ? requiredRules
                                          : selectableRules
                                      "
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="
                                      selected.user_date_entries[date_item_key]
                                        .userStartDate
                                    "
                                    no-title
                                    @input="select_start_date_menu = false"
                                    :first-day-of-week="1"
                                    @change="onChangeDates(date_item_key)"
                                  ></v-date-picker>
                                </v-menu>
                                <span v-else>
                                  {{ date_item?.userStartDate }}
                                </span>
                              </td>
                              <td class="text-center">
                                <v-menu
                                  ref="end_date_menu"
                                  v-model="select_end_date_menu"
                                  :close-on-content-click="false"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="auto"
                                  v-if="
                                    isLastUserDateEntry(
                                      selected.user_date_entries,
                                      date_item_key
                                    )
                                  "
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="
                                        selected.user_date_entries[
                                          date_item_key
                                        ].userEndDate
                                      "
                                      v-bind:label="$t('brands.end_date')"
                                      prepend-icon="mdi-calendar"
                                      v-bind="attrs"
                                      v-on="on"
                                      readonly
                                      required
                                      :rules="
                                        selected.isSelectableDates
                                          ? requiredRules
                                          : selectableRules
                                      "
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="
                                      selected.user_date_entries[date_item_key]
                                        .userEndDate
                                    "
                                    no-title
                                    scrollable
                                    @input="select_end_date_menu = false"
                                    :first-day-of-week="1"
                                    @change="onChangeDates(date_item_key)"
                                  ></v-date-picker>
                                </v-menu>
                                <span v-else>
                                  {{ date_item?.userEndDate }}
                                </span>
                              </td>
                              <td class="text-center">
                                <v-icon
                                  color="red"
                                  v-if="
                                    isLastUserDateEntry(
                                      selected.user_date_entries,
                                      date_item_key
                                    ) && selected.user_date_entries.length > 1
                                  "
                                  @click="removeLastDateEntry()"
                                >
                                  mdi-delete
                                </v-icon>
                              </td>
                            </tr>
                          </template>
                        </table>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="12" md="6">
                    <v-autocomplete
                      v-model="selected.km_in_liquidation"
                      v-bind:label="$t('km_in_liquidations')"
                      :items="km_in_liquidations"
                      filled
                      required
                      :rules="requiredRules"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-autocomplete
                      v-model="selected.liquidationType"
                      v-bind:label="$t('Liquidation Type')"
                      :items="liquidationTypes"
                      item-text="label"
                      item-value="value"
                      filled
                      required
                      :rules="requiredRules"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <v-select
                      v-model="selected.vehicleType"
                      :label="'Tipo de vehículo'"
                      :items="vehicleTypeOptions"
                      item-text="label"
                      item-value="value"
                      filled
                      required
                      :rules="requiredRules"
                    ></v-select>
                  </v-col>
                </v-row>
                <!-- <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    class="d-flex justify-center"
                  >
                    <v-radio-group
                      v-model="selected.status"
                      row
                      required
                      :rules="requiredRules"
                    >
                      <v-radio label="Active" value="active"></v-radio>
                      <v-radio label="Inactive" value="inactive"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row> -->
                <v-row v-if="selected.id !== undefined">
                  <v-row
                    v-for="(entry,
                    index) in selected.additional_static_pendingholidays"
                    v-bind:key="index"
                    align="center"
                  >
                    <v-col cols="12" sm="4" md="4">
                      <v-text-field
                        v-model="entry.appliedYear"
                        v-bind:label="$t('Year')"
                        clearable
                        :rules="yearRules"
                        @input="onChangeAdditionalPendingHolidayYear"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                      <v-text-field
                        v-model="entry.pendingholidays"
                        v-bind:label="$t('holidaypending')"
                        :type="'number'"
                        clearable
                        :rules="additionalHolidayRules"
                        @input="onChangeAdditionalPendingHolidayValue"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      sm="4"
                      md="4"
                      lg="4"
                      v-if="
                        index !=
                          selected.additional_static_pendingholidays.length - 1
                      "
                      ><v-icon color="red" @click="deletePendingHoliday(index)">
                        mdi-delete
                      </v-icon></v-col
                    >
                  </v-row>
                </v-row>
                <v-row v-if="selected.id !== undefined">
                  <v-col cols="12" sm="12" md="12" lg="12">
                    <v-btn
                      color="primary"
                      class="ml-2 white--text"
                      @click="addNewPendingHoliday"
                    >
                      <v-icon dark>mdi-plus</v-icon> añadir
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">
                {{ $t("cancel") }}
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :loading="isSaving"
                @click="onSaveClick(selected)"
              >
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h6">{{
            $t("salesforce.user_confirmdelete")
          }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete">{{
              $t("cancel")
            }}</v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirm"
              >OK</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-btn
              v-if="!isManager"
              color="primary"
              dark
              class="mb-2"
              @click="onItemEdit"
            >
              {{ $t("newitem") }}
            </v-btn>
            <v-btn
              color="primary"
              @click="downloadExcelTemplateAPI('USERS')"
              class="mb-2 ml-2"
            >
              <b-icon icon="download" aria-hidden="true"></b-icon>
              Plantilla Import
            </v-btn>
            <v-btn
              v-if="!isManager"
              color="success"
              dark
              class="mb-2 ml-2"
              :loading="isSelecting"
              @click="onUploadExcelClick"
            >
              <b-icon icon="file-excel-fill" aria-hidden="true"></b-icon>
              {{ buttonText }}
            </v-btn>
            <input
              ref="uploader"
              class="d-none"
              type="file"
              accept=".xls,.xlsx"
              @change="onFileChanged"
            />
            <v-btn
              color="warning"
              dark
              class="mb-2 ml-2"
              @click="downloadExcel"
            >
              <b-icon icon="file-excel-fill" aria-hidden="true"></b-icon>
              Export Excel
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <ve-table
              id="users_table"
              fixed-header
              max-height="calc(100vh - 330px)"
              :columns="columns"
              :table-data="users"
              :border-around="true"
              :border-x="true"
              :border-y="true"
              :scroll-width="1500"
              :sort-option="sortOption"
              :cell-style-option="cellStyleOption"
            />
            <div v-show="showEmpty" class="empty-data">Data Empty.</div>
            <div class="table-pagination mt-2 text-right">
              <ve-pagination
                :total="totalusers"
                :page-index="pageIndex"
                :page-size="pageSize"
                :page-size-option="pageOptions"
                @on-page-number-change="pageNumberChange"
                @on-page-size-change="pageSizeChange"
              />
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/services/apiService";
import { logInfo, logError } from "@/utils";
import _ from "lodash";
import download from "js-file-download";
import moment from "moment";
import haversine from "haversine-distance";

export default {
  name: "Users",
  data: function() {
    return {
      totalusers: 0,
      users: [],
      /********** vue-easytable options **********/
      loadingInstance: null,
      sorting: null,
      sortOption: {
        sortChange: params => {
          this.sortChange(params);
        }
      },
      pageIndex: 1,
      pageSize: 100,
      pageOptions: [10, 50, 100],
      filterable_col_list: [
        "username",
        "name",
        "surname",
        "residence",
        "domainName",
        "role",
        "department",
        "parent_user_name",
        "route_value",
        "status",
        "km_in_liquidation",
        "coche_empresa",
        "address",
        "email",
        "phone",
        "phone_company",
        "dni",
        "dateEndOfVacation",
        "start_date",
        "end_date",
        "project",
        "companyCode",
        "discount_km",
        "liquidationType"
      ],
      vehicleTypeOptions: [
        { label: 'Vehiculo Propio', value: 'OWNVEHICLE' },
        { label: 'Vehiculo de empresa', value: 'COMPANYVEHICLE' }
      ],
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (this.filterable_col_list.includes(column.field)) {
            return "filterable-column " + column.field;
          }
        },
        bodyCellClass: ({ row, column, rowIndex }) => {
          if (rowIndex % 2 !== 0) {
            return "table-body-cell-even";
          } else {
            return "table-body-cell-odd";
          }
        }
      },
      filterCriteria: {
        role: {},
        department: {},
        status: {},
        km_in_liquidation: {},
        "coche_empresa": {},
        dateEndOfVacation: {},
        start_date: {},
        end_date: {},
        discount_km: {},
        companyCode: {},
        liquidationType: {}
      },
      showEmpty: false,

      loading: true,
      options: {},
      editedIndex: -1,
      selected: null,
      valid: true,
      requiredRules: [v => !!v || "Required"],
      selectableRules: [
        v => !!v || "Required",
        v => "Las fechas de varias inscripciones no deben superponerse."
      ],
      usernameRules: [
        v => !!v || "Required",
        v => !v || v.length < 10 || "¡Desborde la longitud!"
      ],
      lengthRules: [v => !v || v.length < 10 || "¡Desborde la longitud!"],
      emailRules: [
        v => !!v || "Required",
        v =>
          !v ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid"
      ],
      yearRules: [v => !v || v > 1970 || "Incorrect Year !"],
      additionalHolidayRules: [
        v => !v || (v >= -22 && v < 23) || "Incorrect Pending Holiday !"
      ],
      requiredRulesArray: [v => (!!v && v.length > 0) || "Required"],
      showEdit: false,
      dialogDelete: false,
      deleteItemId: -1,
      user_type: [],
      departments: [],
      companies: [],
      landingPages: [],
      provinceOptions: [],
      user_status: ["active", "inactive"],
      km_in_liquidations: ["Yes", "No"],
      routes: [],
      liquidationTypes: [],

      tempAddr: null,

      isManualAddress: false,
      addressAutoComplete: null,
      isTooFarSelectedAddress: false,
      googleAddressPt: null,
      manualData: null,

      parent_items: [],
      isParentLoading: false,
      search: null,
      user_list: [],
      select_start_date_menu: false,
      select_end_date_menu: false,

      search_projects: null,
      isProjectsSearching: false,
      filtered_projects: [],
      isSaving: false,

      filtered_surveys: [],
      search_surveys: null,
      isSearching: {},

      filtered_reports: [],
      search_reports: null,

      /********** others **********/
      isSelecting: false,
      selectedFile: null,
      defaultButtonText: "Import Excel",
      /********** snackbar **********/
      snackbar: false,
      text_snackbar: "The imported file is invalid.",
      vertical: true,
      snackbar_class: "deep-purple",

      /************************************* Loading Spinner Overlay ************************************/
      isLoadingSpinner: false
    };
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi();
      },
      deep: true
    },
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    async search(val) {
      await this.searchParent(val);
    },
    async search_projects(val) {
      this.search_brands(val || "");
    },
    async search_surveys(val) {
      this.search_survey_val(val || "");
    },
    async search_reports(val) {
      this.search_report_val(val || "");
    },
    "selected.role"(newRole, oldRole) {
      // Force validation update when role changes
      if (this.$refs.form) {
        this.$nextTick(() => {
          this.$refs.form.resetValidation();
        });
      }
    }
  },
  computed: {
    ...mapGetters("auth", ["isManager"]),
    isRequiredRoute() {
      let ret = false;
      if (this.selected && this.selected?.role && this.selected.role == "gpv") {
        ret = true;
      }
      return ret;
    },
    // brandReportsValidationRules() {
    //   if (this.selected && this.selected.role === "brand") {
    //     return [
    //       v => (!!v && Array.isArray(v) && v.length > 0) || "Reportes es requerido"
    //     ];
    //   }
    //   return [];
    // },
    formTitle() {
      return this.editedIndex === -1 || this.editedIndex === undefined
        ? this.$t("newitem")
        : this.$t("edititem");
    },
    col_edit() {
      return {
        key: "q",
        title: this.$t("salesforce.Edit"),
        field: "actions",
        align: "center",
        width: 100,
        fixed: "right",
        renderBodyCell: ({ row, column, rowIndex }, h) => {
          return (
            <div>
              <v-icon
                medium
                color="primary"
                class="mr-2"
                on-click={() => this.onItemEdit(row)}
              >
                mdi-pencil
              </v-icon>
            </div>
          );
        }
      };
    },
    col_resetpassword() {
      return {
        key: "password",
        title: this.$t("salesforce.Password"),
        field: "password",
        align: "left",
        width: 100,
        renderBodyCell: ({ row, column, rowIndex }, h) => {
          return (
            <div>
              <v-btn
                color="primary"
                dark
                small
                on-click={() => this.onResetPassword(row.id)}
              >
                {this.$t("Reset")}
              </v-btn>
            </div>
          );
        }
      };
    },
    columns() {
      let common_cols = [
        {
          key: "id",
          title: "ID",
          field: "id",
          align: "left",
          width: 70,
          sortBy: "ASC",
          fixed: "left"
        },
        {
          key: "username",
          title: this.$t("salesforce.UserName"),
          field: "username",
          align: "left",
          width: 200,
          sortBy: "",
          fixed: "left",
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  <v-text-field
                    value={this.filterCriteria["username"]}
                    on-input={value =>
                      (this.filterCriteria["username"] = value)
                    }
                    placeholder="Search username"
                  ></v-text-field>
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchCancel(closeFn, "username")}
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },
        {
          key: "name",
          title: this.$t("salesforce.name"),
          field: "name",
          align: "left",
          width: 150,
          sortBy: "",
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  <v-text-field
                    value={this.filterCriteria["name"]}
                    on-input={value => (this.filterCriteria["name"] = value)}
                    placeholder="Search name"
                  ></v-text-field>
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchCancel(closeFn, "name")}
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },
        {
          key: "surname",
          title: this.$t("salesforce.SurName"),
          field: "surname",
          align: "left",
          width: 150,
          sortBy: "",
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  <v-text-field
                    value={this.filterCriteria["surname"]}
                    on-input={value => (this.filterCriteria["surname"] = value)}
                    placeholder="Search surname"
                  ></v-text-field>
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchCancel(closeFn, "surname")}
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },
        {
          key: "email",
          title: this.$t("salesforce.email"),
          field: "email",
          align: "left",
          width: 200,
          sortBy: "",
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  <v-text-field
                    value={this.filterCriteria["email"]}
                    on-input={value => (this.filterCriteria["email"] = value)}
                    placeholder="Search email"
                  ></v-text-field>
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchCancel(closeFn, "email")}
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },
        {
          key: "domainId",
          title: "Dominio",
          field: "domainId",
          align: "left",
          width: 100,
          sortBy: "DESC"
        },
        {
          key: "domainName",
          title: "Nombre de dominio",
          field: "domainName",
          align: "left",
          width: 200,
          sortBy: "ASC",
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  <v-text-field
                    value={this.filterCriteria["domainName"]}
                    on-input={value =>
                      (this.filterCriteria["domainName"] = value)
                    }
                    placeholder="Search Domain Name"
                  ></v-text-field>
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchCancel(closeFn, "domainName")}
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },
        {
          key: "anadimos_exports",
          title: "Añadimos Exports",
          field: "anadimos_exports",
          align: "left",
          width: 200,
          sortBy: ""
        },
        {
          key: "phone",
          title: this.$t("salesforce.phone"),
          field: "phone",
          align: "left",
          width: 200,
          sortBy: "",
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  <v-text-field
                    value={this.filterCriteria["phone"]}
                    on-input={value => (this.filterCriteria["phone"] = value)}
                    placeholder="Search phone"
                  ></v-text-field>
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchCancel(closeFn, "phone")}
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },
        {
          key: "phone_company",
          title: this.$t("salesforce.phone_company"),
          field: "phone_company",
          align: "left",
          width: 200,
          sortBy: "",
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  <v-text-field
                    value={this.filterCriteria["phone_company"]}
                    on-input={value =>
                      (this.filterCriteria["phone_company"] = value)
                    }
                    placeholder="Search phone company"
                  ></v-text-field>
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() =>
                        this.searchCancel(closeFn, "phone_company")
                      }
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },
        {
          key: "dni",
          title: this.$t("salesforce.dni"),
          field: "dni",
          align: "left",
          width: 200,
          sortBy: "",
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  <v-text-field
                    value={this.filterCriteria["dni"]}
                    on-input={value => (this.filterCriteria["dni"] = value)}
                    placeholder="Search DNI"
                  ></v-text-field>
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchCancel(closeFn, "dni")}
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },

        {
          key: "address",
          title: "Dirección",
          field: "address",
          align: "left",
          width: 200,
          sortBy: "",
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  <v-text-field
                    value={this.filterCriteria["address"]}
                    on-input={value => (this.filterCriteria["address"] = value)}
                    placeholder="Search dirección"
                  ></v-text-field>
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchCancel(closeFn, "address")}
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },
        {
          key: "residence",
          title: this.$t("salesforce.ResidenceCity"),
          field: "residence",
          align: "left",
          width: 200,
          sortBy: "",
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  <v-text-field
                    value={this.filterCriteria["residence"]}
                    on-input={value =>
                      (this.filterCriteria["residence"] = value)
                    }
                    placeholder="Search residence"
                  ></v-text-field>
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchCancel(closeFn, "residence")}
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },

        {
          key: "provincia",
          title: "Provincia",
          field: "provincia",
          align: "left",
          width: 150,
          sortBy: "",
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  <v-text-field
                    value={this.filterCriteria["provincia"]}
                    on-input={value =>
                      (this.filterCriteria["provincia"] = value)
                    }
                    placeholder="Search provincia"
                  ></v-text-field>
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchCancel(closeFn, "provincia")}
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },
        {
          key: "companyCode",
          title: this.$t("Company"),
          field: "companyCode",
          align: "left",
          width: 200,
          sortBy: "",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return <span>{row.company && row.company.name}</span>;
          },
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  {this.companies.map(item => {
                    return (
                      <v-checkbox
                        v-model={this.filterCriteria["companyCode"][item.id]}
                        label={item.name}
                        value={item.id}
                      ></v-checkbox>
                    );
                  })}
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchCancel(closeFn, "companyCode")}
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },
        {
          key: "role",
          title: this.$t("salesforce.user_type"),
          field: "role",
          align: "left",
          width: 150,
          sortBy: "",
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  {this.user_type.map(item => {
                    return (
                      <v-checkbox
                        v-model={this.filterCriteria["role"][item]}
                        label={item}
                        value={item}
                      ></v-checkbox>
                    );
                  })}
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchCancel(closeFn, "role")}
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },
        {
          key: "parent_user_name",
          title: this.$t("salesforce.Parent"),
          field: "parent_user_name",
          align: "left",
          width: 150,
          sortBy: "",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return <span>{row.Parent && row.Parent.username}</span>;
          },
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  <v-text-field
                    value={this.filterCriteria["parent_user_name"]}
                    on-input={value =>
                      (this.filterCriteria["parent_user_name"] = value)
                    }
                    placeholder="Search parent"
                  ></v-text-field>
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() =>
                        this.searchCancel(closeFn, "parent_user_name")
                      }
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },
        {
          key: "department",
          title: this.$t("salesforce.department"),
          field: "department",
          align: "left",
          width: 150,
          sortBy: "",
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  {this.departments.map(item => {
                    return (
                      <v-checkbox
                        v-model={this.filterCriteria["department"][item]}
                        label={item}
                        value={item}
                      ></v-checkbox>
                    );
                  })}
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchCancel(closeFn, "department")}
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },
        {
          key: "project",
          title: this.$t("project"),
          field: "project",
          align: "left",
          width: 200,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            let brand_names = row.brands.map(item => item.name);
            return <span>{brand_names.join(", ")}</span>;
          },
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  <v-text-field
                    value={this.filterCriteria["project"]}
                    on-input={value => (this.filterCriteria["project"] = value)}
                    placeholder="Search project"
                  ></v-text-field>
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchCancel(closeFn, "project")}
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },
        {
          key: "route_value",
          title: this.$t("salesforce.Route(s)"),
          field: "route_value",
          align: "left",
          width: 150,
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  <v-text-field
                    value={this.filterCriteria["route_value"]}
                    on-input={value =>
                      (this.filterCriteria["route_value"] = value)
                    }
                    placeholder="Search ..."
                  ></v-text-field>
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchCancel(closeFn, "route_value")}
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
          // filterCustom: {
          //   defaultVisible: false,
          //   render: ({ showFn, closeFn }, h) => {
          //     return (
          //       <div class="custom-filter">
          //         {this.routes.map((item) => {
          //           return (
          //             <v-checkbox
          //               v-model={this.filterCriteria["route_value"]}
          //               label={item.name}
          //               value={item.id}
          //             ></v-checkbox>
          //           );
          //         })}
          //         <div class="custom-filter-operation">
          //           <v-btn
          //             color="blue darken-1"
          //             text
          //             on-click={() => this.searchCancel(closeFn, "route_value")}
          //           >
          //             {this.$t("cancel")}
          //           </v-btn>
          //           <v-btn
          //             color="blue darken-1"
          //             text
          //             on-click={() => this.searchConfirm(closeFn)}
          //           >
          //             {this.$t("Search")}
          //           </v-btn>
          //         </div>
          //       </div>
          //     );
          //   },
          // },
        },
        {
          key: "liquidationType",
          title: this.$t("Liquidation Type"),
          field: "liquidationType",
          align: "left",
          width: 200,
          sortBy: "",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return <span>{row.liquidationTypeLabel}</span>;
          },
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  <filterableCheckboxesOthers
                    v-model={this.filterCriteria["liquidationType"]}
                    dataList={this.liquidationTypes}
                    filterCriteria={this.filterCriteria["liquidationType"]}
                    itemvalue="value"
                    itemlabel="label"
                  />
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() =>
                        this.searchCancel(closeFn, "liquidationType")
                      }
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },
        {
          key: "discount_km",
          title: this.$t("discount_km"),
          field: "discount_km",
          align: "left",
          width: 150,
          sortBy: "",
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  <input
                    type="number"
                    class="filter_date_picker"
                    v-model={this.filterCriteria["discount_km"]["from"]}
                    value={this.filterCriteria["discount_km"]["from"]}
                    placeholder="From - "
                  />
                  <br />
                  <input
                    type="number"
                    class="filter_date_picker"
                    v-model={this.filterCriteria["discount_km"]["to"]}
                    value={this.filterCriteria["discount_km"]["to"]}
                    placeholder="To - "
                  />
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchCancel(closeFn, "discount_km")}
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },
        {
          key: "km_in_liquidation",
          title: this.$t("km_in_liquidations"),
          field: "km_in_liquidation",
          align: "left",
          width: 150,
          sortBy: "",
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  {this.km_in_liquidations.map(item => {
                    return (
                      <v-checkbox
                        v-model={this.filterCriteria["km_in_liquidation"][item]}
                        label={item}
                        value={item}
                      ></v-checkbox>
                    );
                  })}
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() =>
                        this.searchCancel(closeFn, "km_in_liquidacion")
                      }
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },
        {
          key: "coche_empresa",
          title: "Coche empresa",
          field: "coche_empresa",
          align: "left",
          width: 150,
          sortBy: "",
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  <v-checkbox
                    v-model={this.filterCriteria["coche_empresa"]["Si"]}
                    label="Si"
                    value="Si"
                  ></v-checkbox>
                  <v-checkbox
                    v-model={this.filterCriteria["coche_empresa"]["No"]}
                    label="No"
                    value="No"
                  ></v-checkbox>
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchCancel(closeFn, "coche_empresa")}
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },
        {
          key: "dateEndOfVacation",
          title: `Fecha Fin Vacaciones`,
          field: "dateEndOfVacation",
          align: "left",
          width: 150,
          sortBy: "",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.dateEndOfVacation &&
                  moment(row.dateEndOfVacation).format("DD/MM")}
              </span>
            );
          },
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  <input
                    type="date"
                    class="filter_date_picker"
                    v-model={this.filterCriteria["dateEndOfVacation"]["from"]}
                    value={this.filterCriteria["dateEndOfVacation"]["from"]}
                    placeholder="From - "
                  />
                  <br />
                  <input
                    type="date"
                    class="filter_date_picker"
                    v-model={this.filterCriteria["dateEndOfVacation"]["to"]}
                    value={this.filterCriteria["dateEndOfVacation"]["to"]}
                    placeholder="To - "
                  />
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() =>
                        this.searchCancel(closeFn, "dateEndOfVacation")
                      }
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },
        {
          key: "f",
          title: this.$t("brands.start_date"),
          field: "start_date",
          align: "left",
          width: 150,
          sortBy: "",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.start_date !== null
                  ? moment(row.start_date)
                      .local()
                      .format("DD/MM/YYYY")
                  : ""}
              </span>
            );
          },
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  <input
                    type="date"
                    class="filter_date_picker"
                    v-model={this.filterCriteria["start_date"]["from"]}
                    value={this.filterCriteria["start_date"]["from"]}
                    placeholder="From - "
                  />
                  <br />
                  <input
                    type="date"
                    class="filter_date_picker"
                    v-model={this.filterCriteria["start_date"]["to"]}
                    value={this.filterCriteria["start_date"]["to"]}
                    placeholder="To - "
                  />
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchCancel(closeFn, "start_date")}
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },
        {
          key: "g",
          title: this.$t("brands.end_date"),
          field: "end_date",
          align: "left",
          width: 150,
          sortBy: "",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.end_date !== null
                  ? moment(row.end_date)
                      .local()
                      .format("DD/MM/YYYY")
                  : ""}
              </span>
            );
          },
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  <input
                    type="date"
                    class="filter_date_picker"
                    v-model={this.filterCriteria["end_date"]["from"]}
                    value={this.filterCriteria["end_date"]["from"]}
                    placeholder="From - "
                  />
                  <br />
                  <input
                    type="date"
                    class="filter_date_picker"
                    v-model={this.filterCriteria["end_date"]["to"]}
                    value={this.filterCriteria["end_date"]["to"]}
                    placeholder="To - "
                  />
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchCancel(closeFn, "end_date")}
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        },
        {
          key: "status",
          title: this.$t("salesforce.status"),
          field: "status",
          align: "left",
          width: 150,
          sortBy: "",
          filterCustom: {
            defaultVisible: false,
            render: ({ showFn, closeFn }, h) => {
              return (
                <div class="custom-filter">
                  {this.user_status.map(item => {
                    return (
                      <v-checkbox
                        v-model={this.filterCriteria["status"][item]}
                        label={item}
                        value={item}
                      ></v-checkbox>
                    );
                  })}
                  <div class="custom-filter-operation">
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchCancel(closeFn, "status")}
                    >
                      {this.$t("cancel")}
                    </v-btn>
                    <v-btn
                      color="blue darken-1"
                      text
                      on-click={() => this.searchConfirm(closeFn)}
                    >
                      {this.$t("Search")}
                    </v-btn>
                  </div>
                </div>
              );
            }
          }
        }
      ];
      if (!this.isManager) {
        return [...common_cols, this.col_resetpassword, this.col_edit];
      } else {
        return [...common_cols];
      }
    },
    buttonText() {
      return this.isSelecting ? "Uploading..." : this.defaultButtonText;
    },
    // Function is returns province items with the current province at the beginning if it's not already included.
    provinceItems() {
      const current = this.selected?.provincia;
      if (current && !this.provinceOptions.includes(current)) return [current, ...this.provinceOptions];
      return this.provinceOptions;
    },
  },
  methods: {
    // [Added by E2logy]: Function is used to normalise the province list.
    normalizeProvinceOptions(items = []) {
      const names = (Array.isArray(items) ? items : [])
        .map(item => (typeof item === "string" ? item : item?.name))

      return [...new Set(names)].sort((a, b) =>
        a.localeCompare(b, "es", { sensitivity: "base" })
      );
    },
    
    onChangeDates(date_item_key) {
      if (date_item_key >= 0) {
        if (
          this.selected.user_date_entries[date_item_key].userStartDate >
          this.selected.user_date_entries[date_item_key].userEndDate
        ) {
          this.selected.user_date_entries[
            date_item_key
          ].userEndDate = this.selected.user_date_entries[
            date_item_key
          ].userStartDate;
        }
        if (
          this.selected.user_date_entries[date_item_key].userStartDate &&
          this.selected.user_date_entries[date_item_key].userEndDate
        ) {
          let isOverlapped = false;
          let currentStartDate = this.selected.user_date_entries[date_item_key]
            .userStartDate;
          let currentEndDate = this.selected.user_date_entries[date_item_key]
            .userEndDate;
          this.selected.user_date_entries.map((entry, index) => {
            if (index !== date_item_key) {
              if (
                (currentStartDate >= entry.userStartDate &&
                  currentStartDate <= entry.userEndDate) ||
                (currentEndDate >= entry.userStartDate &&
                  currentEndDate <= entry.userEndDate) ||
                (currentStartDate >= entry.userStartDate &&
                  currentEndDate <= entry.userEndDate)
              ) {
                isOverlapped = true;
              }
            }
          });
          this.selected.isSelectableDates = !isOverlapped;
        }
      }
    },
    removeLastDateEntry() {
      if (this.selected.user_date_entries.length > 1) {
        this.selected.user_date_entries.pop();
      }
    },
    addNewDateEntry() {
      let isAddAvailable = false;
      if (this.selected && this.selected?.user_date_entries) {
        if (this.selected.user_date_entries.length > 0) {
          let lastItem = this.selected.user_date_entries[
            this.selected.user_date_entries.length - 1
          ];
          if (lastItem?.userStartDate && lastItem?.userEndDate) {
            isAddAvailable = true;
          }
        } else {
          isAddAvailable = true;
        }
      }
      if (isAddAvailable) {
        let push_item = {
          userStartDate: null,
          userEndDate: null,
          orderNum: this.selected.user_date_entries.length + 1
        };
        this.selected.user_date_entries.push(push_item);
      }
    },
    isLastUserDateEntry(user_date_entries, key) {
      if (parseInt(key) < user_date_entries.length - 1) return false;
      return true;
    },
    async search_brands(val) {
      this.isProjectsSearching = true;
      let fetch_url = "salesforce/users/get_projects?filter_name=" + val;
      this.prevsearch = val;
      const resp = await ApiService.get(fetch_url);
      this.filtered_projects = resp.data;
      this.isProjectsSearching = false;
    },
    async search_survey_val(val) {
      this.isSearching["surveys"] = true;
      let fetch_url = "/salesforce/users/get_brand_surveys";
      // Prepare payload for new API
      const payload = {
        brands: Array.isArray(this.selected.brands) && this.selected.brands.length ? this.selected.brands : null,
        search: val || "",
        role: this.selected.role || ""
      };
      this.prevsearch = val;
      try {
        const resp = await ApiService.post(fetch_url, payload);
        this.filtered_surveys = resp.success && resp.survey_data ? resp.survey_data : [];
      } catch (e) {
        this.filtered_surveys = [];
      }
      this.isSearching["surveys"] = false;
    },
      async search_report_val(val) {
      this.isSearching["reports"] = true;
      let fetch_url = "/salesforce/users/get_brand_reports";
      
      const brands = Array.isArray(this.selected.brands) ? this.selected.brands : [];
      
      const payload = {
        brands: brands.length > 0 ? brands : null,
        search: val || "",
        role: this.selected.role || ""
      };
      
      this.prevsearch = val;
      try {
        const resp = await ApiService.post(fetch_url, payload);
        this.filtered_reports = resp.success && resp.data ? resp.data : [];
      } catch (error) {
        console.error("Error fetching reports:", error);
        this.filtered_reports = [];
      }
      this.isSearching["reports"] = false;
    },
    async searchParent(val) {
      this.isParentLoading = true;
      let fetch_url = "salesforce/users/get_parent_list?parent_name=" + val;
      const resp = await ApiService.get(fetch_url);
      this.parent_items = resp.data;
      this.isParentLoading = false;
    },
    update_user_type(val) {
      // if (val !== "spv" && val !== "gpv") {
      //   this.selected.parent_id = null;
      // }
    },
    async toggleCantfindAddress() {
      this.isManualAddress = !this.isManualAddress;
      if (this.isManualAddress) {
        // this.manualData = {
        //   town: "",
        //   postalCode: "",
        //   address: "",
        //   addressObservation: ""
        // };
      }
    },

    cancelFilter() {
      for (const [key, value] of Object.entries(this.filterCriteria)) {
        this.filterCriteria[key] = null;
      }
      this.getDataFromApi();
    },

    changeFilter() {
      this.getDataFromApi();
    },

    getQueryParams(options) {
      let query_params_string = "";
      let query_params = [];
      query_params.push("page=" + this.pageIndex);
      query_params.push("itemsPerPage=" + this.pageSize);
      if (this.sorting !== null) {
        for (const [key, value] of Object.entries(this.sorting)) {
          if (value !== null && value !== "") {
            query_params.push("sortby=" + key);
            query_params.push(
              "sortdesc=" + (value === "desc" ? "true" : "false")
            );
          }
        }
      }

      let filterModel = [];
      for (const [key, value] of Object.entries(this.filterCriteria)) {
        if (value !== "" && value !== null) {
          if (key === "start_date" || key === "end_date") {
            let convert_value = {
              from: "",
              to: ""
            };
            if (
              value["from"] !== "" &&
              value["from"] !== null &&
              value["from"] !== undefined
            ) {
              convert_value["from"] = moment(value["from"], "YYYY-MM-DD")
                .utc()
                .format("YYYY-MM-DD HH:mm:ssZ");
              filterModel.push({
                columnField: key,
                filterValue: convert_value
              });
            }
            if (
              value["to"] !== "" &&
              value["to"] !== null &&
              value["to"] !== undefined
            ) {
              convert_value["to"] = moment(value["to"], "YYYY-MM-DD")
                .utc()
                .format("YYYY-MM-DD HH:mm:ssZ");
              filterModel.push({
                columnField: key,
                filterValue: convert_value
              });
            }
          } else if (Object.keys(value).length > 0) {
            filterModel.push({
              columnField: key,
              filterValue: value
            });
          }
        }
      }
      let filter_columns = document.querySelectorAll(".filterable-column");
      for (let i = 0; i < filter_columns.length; i++) {
        filter_columns[i].classList.remove("filter_active");
      }
      if (filterModel.length > 0) {
        filterModel.map(filter_item => {
          for (let i = 0; i < filter_columns.length; i++) {
            if (filter_columns[i].classList.contains(filter_item.columnField)) {
              filter_columns[i].classList.add("filter_active");
            }
          }
          return filter_item;
        });
      }

      query_params_string += query_params.join("&");
      if (filterModel.length > 0) {
        query_params_string +=
          "&filterModel=" + encodeURIComponent(JSON.stringify(filterModel));
      }
      return query_params_string;
    },

    placeChangedListener() {
      var address = this.addressAutoComplete.getPlace();
      if (address && address.address_components) {
        let addressDetail = {
          address: address.formatted_address,
          town: null,
          postalCode: null,
          latitude: null,
          longitude: null
        };
        // types - postal_code
        let postal_code_item = address.address_components.filter(el =>
          el.types.includes("postal_code")
        );
        if (postal_code_item && postal_code_item.length > 0) {
          addressDetail.postalCode = postal_code_item[0].long_name;
        }
        // town types - locality
        let town_item = address.address_components.filter(el =>
          el.types.includes("locality")
        );
        if (town_item && town_item.length > 0) {
          addressDetail.town = town_item[0].long_name;
        }

        this.selected = { ...this.selected, ...addressDetail };
      }
    },

    async getDataFromApi() {
      this.loading = true;
      this.showloadingspinner();
      let query_params_string = this.getQueryParams(this.options);
      let fetch_url = "salesforce/users";
      if (query_params_string !== "") {
        fetch_url += "?" + query_params_string;
      }
      const resp = await ApiService.get(fetch_url);
      this.users = resp.data;
      this.totalusers = resp.total;
      // this.filtered_surveys = resp.survey_data;

      let users = [];
      this.users.map(user => {
        let item = { ...user };
        if (user.Parent !== null) {
          item.parent_user_name = user.Parent.username;
        }
        if (user.routes && user.routes.length > 0) {
          item.route_value = user.routes
            .map(elem => {
              return elem.name;
            })
            .join(",");
        }
        users.push(item);
        return user;
      });

      this.user_type = [];
      for (const [key, role] of Object.entries(resp.user_roles)) {
        this.user_type.push(role);
      }
      this.user_status = Object.values(resp.user_status);
      this.km_in_liquidations = Object.values(resp.km_in_liquidations);
      this.landingPages = Object.values(resp.landingPages);
      if (this.users.length > 0) {
        this.showEmpty = false;
      } else {
        this.showEmpty = true;
      }

      this.departments = resp.dep_data;
      this.routes = resp.route_data;
      this.user_list = resp.user_list;
      this.companies = resp.company_data;

      this.liquidationTypes = resp.liquidationTypes;

      this.users = users;
      this.loading = false;
      this.closeloadingspinner();
    },

    searchConfirm(closeFn) {
      closeFn();
      this.pageIndex = 1;
      this.getDataFromApi();
    },

    searchCancel(closeFn, cancelFilterKey) {
      closeFn();
      if (
        cancelFilterKey === "dateEndOfVacation" ||
        cancelFilterKey === "start_date" ||
        cancelFilterKey === "end_date"
      ) {
        this.filterCriteria[cancelFilterKey]["from"] = "";
        this.filterCriteria[cancelFilterKey]["to"] = "";
      } else if (
        cancelFilterKey === "status" ||
        cancelFilterKey === "km_in_liquidacion" ||
        cancelFilterKey === "role" ||
        cancelFilterKey === "department" ||
        cancelFilterKey === "discount_km" ||
        cancelFilterKey === "liquidationType" ||
        cancelFilterKey === "companyCode" ||
        cancelFilterKey === "coche_empresa"
      ) {
        this.filterCriteria[cancelFilterKey] = {};
      } else {
        this.filterCriteria[cancelFilterKey] = null;
      }
      this.getDataFromApi();
    },
    onItemEdit(item) {
      this.selected = this.createSelectedModel(item);
      this.search_survey_val("");
      this.search_report_val("");
      
      // Clear brandReports if role is not brand
      if (this.selected.role !== "brand") {
        this.selected.brandReports = [];
        this.filtered_reports = [];
      }
      
      this.editedIndex = this.selected.id;
      this.showEdit = true;
      this.onGoogleMapInit();
    },
    onGoogleMapInit() {
      this.$nextTick(() => {
        setTimeout(() => {
          const input = this.$refs.googleaddressbar;
          if (input && window.google?.maps?.places) {
            // Avoid re-initializing
            this.addressAutoComplete = new window.google.maps.places.Autocomplete(
              input
            );
            this.addressAutoComplete.addListener(
              "place_changed",
              this.placeChangedListener
            );
          } else {
            console.warn("Google Maps library not loaded or input missing");
          }
        }, 800); // Delay to allow dialog and transitions to complete
      });
    },

    createSelectedModel(item) {
      let model_start_date = _.get(item, "start_date");
      let model_end_date = _.get(item, "end_date");

      let selected_routes = null;
      let routes = _.get(item, "routes");
      if (routes && routes.length > 0) {
        selected_routes = routes[0].id;
      }

      let brands = _.get(item, "brands");
      let selected_projects = [];
      if (brands && brands.length > 0) {
        brands.map(item => {
          selected_projects.push(item.id);
        });
      }
      this.search_brands("");
      let user_date_entries = _.get(item, "user_date_entries");
      if (!user_date_entries) user_date_entries = [];
      let model = {
        id: _.get(item, "id"),
        username: _.get(item, "username"),
        name: _.get(item, "name"),
        surname: _.get(item, "surname"),
        email: _.get(item, "email"),
        phone: _.get(item, "phone"),
        phone_company: _.get(item, "phone_company"),
        dni: _.get(item, "dni"),
        provincia: _.get(item, "provincia"),
        isEdit: _.get(item, "isEdit") ?? "Editar",
        landingPage: _.get(item, "landingPage") ?? "Portal fotos",
        residence: _.get(item, "residence"),
        address: _.get(item, "address") ?? null,
        role: _.get(item, "role"),
        anadimos_exports: _.get(item, "anadimos_exports"),
        brandSurveys: JSON.parse(_.get(item, "brandSurveys") || "[]"),
        brandReports: JSON.parse(_.get(item, "reportIds") || "[]"),
        parent_id: _.get(item, "parent_id"),
        routes: selected_routes,
        brands: selected_projects,
        status: _.get(item, "status"),
        km_in_liquidation: _.get(item, "km_in_liquidation"),
        liquidationType: _.get(item, "liquidationType"),
        department: _.get(item, "department"),
        project: _.get(item, "project"),
        companyCode: _.get(item, "companyCode"),
        discount_km: _.get(item, "discount_km"),
        dateEndOfVacation: _.get(item, "dateEndOfVacation"),
        user_date_entries,
        isSelectableDates: true,

        fiscalTown: null,
        fiscalPostalCode: null,
        fiscalAddress: null,
        postalCode: _.get(item, "postalCode"),
        addressObservation: _.get(item, "addressObservation"),
        town: _.get(item, "town"),
        vatNumber: null,
        latitude: null,
        longitude: null,

        start_date:
          model_start_date !== undefined && model_start_date !== null
            ? moment(model_start_date).format("YYYY-MM-DD")
            : model_start_date,
        end_date:
          model_end_date !== undefined && model_end_date !== null
            ? moment(model_end_date).format("YYYY-MM-DD")
            : model_end_date,

          vehicleType: _.get(item, "vehicleType") || 'COMPANYVEHICLE'
      };
      this.manualData = {
        address: model.address,
        town: model.town,
        postalCode: model.postalCode,
        addressObservation: model.addressObservation
      };
      if (
        model.user_date_entries.length === 0 &&
        (model?.start_date || model?.end_date)
      ) {
        model.user_date_entries.push({
          userStartDate: model?.start_date,
          userEndDate: model?.end_date,
          orderNum: 1
        });
      }
      if (!model?.dateEndOfVacation) model.dateEndOfVacation = "02-28";
      if (
        model.id &&
        item.staticpendingholidays &&
        item.staticpendingholidays.length > 0
      ) {
        model.additional_static_pendingholidays = item.staticpendingholidays.map(
          el => ({
            appliedYear: el.appliedYear,
            pendingholidays: el.pendingholidays
          })
        );
        model.additional_static_pendingholiday_years =
          item.staticpendingholidays[0].appliedYear;
        model.additional_static_pendingholiday_value =
          item.staticpendingholidays[0].pendingholidays;
      }
      if (!model.additional_static_pendingholidays) {
        model.additional_static_pendingholidays = [];
      }
      model.additional_static_pendingholidays = [
        ...model.additional_static_pendingholidays,
        { appliedYear: "", pendingholidays: "" }
      ];
      return model;
    },

    async onSaveClick(item) {
      // Ensure vehicleType is set
      if (!item.vehicleType) {
        item.vehicleType = 'COMPANYVEHICLE';
      }
      // Force form validation
      const isFormValid = this.$refs.form.validate();
      
      // Additional validation for brandReports field if role is brand
      let isBrandReportsValid = true;
      if (item.role === 'brand' && this.$refs.brandReportsField) {
        isBrandReportsValid = this.$refs.brandReportsField.validate();
      }
      
      // Custom validation for brandReports when role is brand
      // if (item.role === 'brand' && (!item.brandReports || item.brandReports.length === 0)) {
      //   logError("Reportes es requerido para usuarios con rol de marca");
      //   this.isSaving = false;
      //   return;
      // }
      
      if (isFormValid && isBrandReportsValid) {
        let start_date_time = new Date(item.start_date);
        let end_date_time = new Date(item.end_date);
        if (start_date_time - end_date_time > 0) {
          logError(this.$t("Error") + " - " + this.$t("brands.start_date"));
          return;
        }
        if (!item?.user_date_entries || item?.user_date_entries.length === 0) {
          logError(
            `${this.$t("Error")} - ${this.$t("brands.start_date")} ${this.$t(
              "brands.end_date"
            )}`
          );
          return;
        }
        if (
          item?.additional_static_pendingholidays &&
          item?.additional_static_pendingholidays.length
        ) {
          const lastEl = item.additional_static_pendingholidays.at(-1);
          if (!lastEl.appliedYear && !lastEl.pendingholidays)
            item.additional_static_pendingholidays.pop();
        }
        this.isSaving = true;
        const body = _.omit(item);
        // Ensure vehicleType is included in body
        body.vehicleType = item.vehicleType;
        let startdate = moment(body.start_date, "YYYY-MM-DD");
        let enddate = moment(body.end_date, "YYYY-MM-DD");
        if (item.start_date) {
          body.start_date = startdate.utc().format("YYYY-MM-DD HH:mm:ssZ");
        }
        if (item.end_date) {
          body.end_date = enddate.utc().format("YYYY-MM-DD HH:mm:ssZ");
        }

        if (this.isManualAddress) {
          body.address = this.manualData.address;
          body.town = this.manualData.town;
          body.postalCode = this.manualData.postalCode;
          body.addressObservation = this.manualData.addressObservation;
        }

        let save_res = null;

        if(body.brandReports && Array.isArray(body.brandReports) && body.brandReports.length > 0 && body.role === "brand"){
          // do nothing 
        } 
        else {
          body.brandReports = null;
        }
        if (body.id) {
          save_res = await ApiService.put(`salesforce/users/${body.id}`, body);
        } else {
          save_res = await ApiService.post(`salesforce/users`, body);
        }
        if (save_res.success) {
          logInfo("Usuario actualizada");
          this.showEdit = false;
          this.getDataFromApi();
        } else {
          logError(save_res.message);
        }
        this.isSaving = false;
      }
    },

    close() {
      this.showEdit = false;
      this.$nextTick(() => {
        this.selected = null;
        this.editedIndex = -1;
      });
    },

    deletePendingHoliday(index) {
      if (
        this.selected.additional_static_pendingholidays &&
        index >= 0 &&
        index < this.selected.additional_static_pendingholidays.length
      ) {
        this.selected.additional_static_pendingholidays = this.selected.additional_static_pendingholidays.filter(
          (_, id) => id !== index
        );
      } else {
        console.error("Invalid index:", index);
      }
    },

    addNewPendingHoliday() {
      if (this.selected.additional_static_pendingholidays) {
        this.selected.additional_static_pendingholidays = [
          ...this.selected.additional_static_pendingholidays,
          {
            appliedYear: "", // Default value for the new holiday
            pendingholidays: "" // Default value for the new holiday
          }
        ];
      } else {
        console.error("No array found for additional_static_pendingholidays.");
        this.selected.additional_static_pendingholidays = [
          {
            appliedYear: "",
            pendingholidays: ""
          }
        ];
      }
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.deleteItemId = -1;
      });
    },

    onItemRemove(item_id) {
      this.deleteItemId = item_id;
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      if (this.deleteItemId > 0) {
        this.closeDelete();
        ApiService.delete(`salesforce/users/${this.deleteItemId}`).then(() => {
          logInfo("Usuario eliminada");
          this.getDataFromApi();
        });
      }
    },

    onResetPassword(item_id) {
      if (window.confirm(this.$t("salesforce.reset_password_confirm"))) {
        ApiService.post(`salesforce/users/resetpassword/${item_id}`).then(
          () => {
            logInfo("operador eliminado");
          }
        );
      }
    },

    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
      this.getDataFromApi();
    },

    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
      this.getDataFromApi();
    },

    sortChange(params) {
      this.sorting = params;
      this.getDataFromApi();
    },

    showloadingspinner() {
      this.loadingInstance = this.$veLoading({
        target: document.querySelector("#users_table"),
        name: "flow" // gird, flow, wave, bounce,
      });
      this.loadingInstance.show();
    },
    closeloadingspinner() {
      this.loadingInstance.close();
    },

    async downloadExcel() {
      this.showloadingspinner();
      let query_params_string = this.getQueryParams();
      let fetch_url = "salesforce/users/downloadexcel";
      if (query_params_string !== "") {
        fetch_url += "?" + query_params_string;
      }
      try {
        const response = await ApiService.get(fetch_url, {
          responseType: "blob"
        });
        download(response, "users.xlsx");
        this.closeloadingspinner();
      } catch (error) {
        this.closeloadingspinner();
      }
    },

    onUploadExcelClick() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: false }
      );
      this.$refs.uploader.click();
    },
    async onFileChanged(e) {
      this.selectedFile = e.target.files[0];
      if (
        window.confirm(
          `¿Está seguro de que desea cargar este archivo de Excel?`
        )
      ) {
        this.isSelecting = true;
        this.isLoadingSpinner = true;
        let data = new FormData();
        data.append("file", this.selectedFile);
        this.$refs.uploader.value = "";
        try {
          const response = await ApiService.post(
            `salesforce/users/uploadexcel`,
            data,
            {
              headers: {
                "Content-Type": `multipart/form-data;`
              }
            }
          );
          const {
            success,
            insertedRowCount,
            failedRows,
            invalidFile,
            message
          } = response;
          this.snackbar_class = "deep-purple";
          if (success && insertedRowCount > 0) {
            this.text_snackbar = `${insertedRowCount} row${
              insertedRowCount > 1 ? "s" : ""
            } imported successfully`;
            this.snackbar = true;
            this.getDataFromApi();
          } else if (failedRows) {
            this.text_snackbar = `Inserted count: ${response.insertedRowCount}, Failed count: ${response.failedRows.length}`;
            this.snackbar = true;
            this.exportCSVfileGlobal(response.titles, response.failedRows);
            this.getDataFromApi();
          } else if (!invalidFile && message) {
            this.text_snackbar = message;
            this.snackbar_class = "red";
            this.snackbar = true;
          }
          this.isSelecting = false;
          this.isLoadingSpinner = false;
        } catch (error) {
          console.log(error);
        }
      }
    },

    async onChangeAdditionalPendingHolidayYear() {
      await this.changeAdditionalPendingHoliday();
    },

    async onChangeDateEndOfVacation() {
      if (this.selected) {
        let dateEndOfVacation = this.selected.dateEndOfVacation;
        if (dateEndOfVacation) {
          let date_value = new Date(dateEndOfVacation);
          if (date_value && date_value != "Invalid Date") {
            date_value = moment(date_value).format("MM-DD");
            this.selected.dateEndOfVacation = date_value;
          } else {
            this.selected.dateEndOfVacation = "";
          }
        }
      }
    },

    async onChangeAdditionalPendingHolidayValue() {
      console.log(this.selected.additional_static_pendingholiday_value);
    },

    async changeAdditionalPendingHoliday() {
      const {
        id,
        additional_static_pendingholiday_year,
        additional_static_pendingholiday_value
      } = this.selected;
      if (id && additional_static_pendingholiday_year > 1970) {
        let fetch_url = `salesforce/users/get_staticpendingholidays?userId=${this.selected.id}&year=${additional_static_pendingholiday_year}`;
        let response = await ApiService.get(fetch_url);
        if (response.data) {
          this.selected.additional_static_pendingholiday_year =
            response.data.appliedYear;
          this.selected.additional_static_pendingholiday_value =
            response.data.pendingholidays;
        } else {
          this.selected.additional_static_pendingholiday_value = null;
        }
      }
    },

    // [Added by E2logy]: Function is used to fetch the province list. 
    async loadProvinceOptions() {
      try {
        const fetch_url = "pos/get_geographies"
        const resp = await ApiService.get(`${fetch_url}?filter_name=`);
        const rows = Array.isArray(resp?.data) ? resp.data : [];
        console.log("rows" ,rows)
        let options = this.normalizeProvinceOptions(rows);
        console.log("options", options)

        this.provinceOptions = options;
      } catch (error) {
        console.error("Error loading provinces:", error);
        this.provinceOptions = [];
      }
    },

    async init() {
      await this.getDataFromApi();
      await this.loadProvinceOptions();
    },

    async onBrandOrRoleChange() {
    if (this.selected) {
      this.selected.brandReports = [];
      this.filtered_reports = [];
    }
    
    if (this.$refs.form) {
      this.$refs.form.resetValidation();
    }
    
    if (this.selected && this.selected.role !== "brand") {
      this.selected.brandReports = [];
    }
    
    this.isSurveyLoading = true;
    this.isSearching = { ...this.isSearching, reports: true };
    try {
      const brands = Array.isArray(this.selected.brands) ? this.selected.brands : [];
      
      const payload = {
        role: this.selected.role,
        brands: brands.length > 0 ? brands : null  
      };
      
      this.isSurveyLoading = true;
      this.isSearching = { ...this.isSearching, reports: true };
      try {
        const payload = {
          role: this.selected.role,
          brands: this.selected.brands
        };
        
        // Call surveys API
        const resp = await ApiService.post(
          "/salesforce/users/get_brand_surveys",
          payload
        );

        if (resp.success) {
          this.filtered_surveys = resp.survey_data || [];
        } else {
          this.filtered_surveys = [];
        }

        // Call reports API with the same payload
        const reportsResp = await ApiService.post(
          "/salesforce/users/get_brand_reports",
          payload
        );

        if (reportsResp.success) {
          this.filtered_reports = reportsResp.data || [];
        } else {
          this.filtered_reports = [];
        }

        if (this.selected && Array.isArray(this.selected.brandReports)) {
          const allowedReportIds = new Set(
            this.filtered_reports.map(report => String(report.id))
          );
          this.selected.brandReports = this.selected.brandReports.filter(
            reportId => allowedReportIds.has(String(reportId))
          );
        }
      } catch (error) {
        console.log("Error: ", error);
        this.filtered_surveys = [];
      }

      const reportsResp = await ApiService.post(
        "/salesforce/users/get_brand_reports",
        payload
      );

      if (reportsResp.success) {
        this.filtered_reports = reportsResp.data || [];
      } else {
        this.filtered_reports = [];
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      this.filtered_surveys = [];
      this.filtered_reports = [];
    }
    this.isSurveyLoading = false;
    this.isSearching = { ...this.isSearching, reports: false };
  }
  },

  async mounted() {
    this.init();
  }
};
</script>

<style>
.v-btn {
  text-transform: capitalize;
}
table tr td .v-btn {
  margin-bottom: 0 !important;
}
.filter_row td {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
td.ve-table-body-td.table-body-cell-even {
  background: #ddd !important;
}
input.googleAddressFinder {
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  width: 100%;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 8px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition-property: height, min-height;
  margin-top: 16px;
  font-size: 16px;
  height: 33px;
}
</style>
